import {ChangeDetectorRef, Injectable, OnDestroy, SecurityContext} from '@angular/core';
import {Observable, Subject} from 'rxjs';
import {TranslationService} from './translation.service';
import {takeUntil} from 'rxjs/operators';
import {TranslationFormModel} from '../models/translation.model';
import {FuseSplashScreenService} from '@barebone-fuse-services/splash-screen.service';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';

@Injectable()
export class TranslationUIService implements OnDestroy {
  private unSubscribe$ = new Subject<void>();
  constructor(private translationService: TranslationService,
              public fuseSplashScreenService: FuseSplashScreenService,
              private sanitizer: DomSanitizer
              ) {
  }

  ngOnDestroy(): void {
    this.unSubscribe$.next();
    this.unSubscribe$.complete();
  }
  public createFrame(id: any) {
    return '<iframe id=' + id + ' type="text/html" width="100%" height="100%" style="border:1px double"></iframe>';
  }

  setIFrameContent(document, frameId, htmlString: any) {
    const iframe = <HTMLIFrameElement>document.getElementById(frameId);
    if(iframe) {
      iframe.src = "about:blank";
      iframe.contentWindow.document.open();
      iframe.contentWindow.document.write(htmlString);
      iframe.contentWindow.document.close();
    }
  }

  setUrlForIFrameContent(document, frameId, url: any) {
    const iframe = <HTMLIFrameElement>document.getElementById(frameId);
    console.log('iframe got:', iframe);
    if(iframe) {
      iframe.src =url;
    }
  }

  getHtmlForm(document, frameId, fileId) {
    this.fuseSplashScreenService.show();
    if(fileId) {
      this.translationService.getFormHtml(fileId).pipe(takeUntil(this.unSubscribe$)).subscribe(html => {
        this.fuseSplashScreenService.hide();
        //console.log('html:', html);
        html.content = this.sanitizeHtml(html.content);
        this.setIFrameContent(document, frameId, html.content);
      }, err => {
        this.fuseSplashScreenService.hide();
        console.log('Form loading failed!!!');
      });
    }
  }
  generatePageNumbers(formModel: TranslationFormModel) {
    if (formModel && formModel.pageCount > 0) {
      formModel.currentPage = 1;
      formModel.pages = Array(formModel.pageCount).fill(0);
    } else {
      formModel.pages = [];
    }
  }

  // Sanitize HTML Content
  sanitizeHtml(html: string): SafeHtml {
    return html;
    // return this.sanitizer.sanitize(SecurityContext.HTML, html) || '';
  }

}

